import { render, staticRenderFns } from "./ViewLogistics.vue?vue&type=template&id=4afc6770&scoped=true&"
import script from "./ViewLogistics.vue?vue&type=script&lang=js&"
export * from "./ViewLogistics.vue?vue&type=script&lang=js&"
import style0 from "./ViewLogistics.vue?vue&type=style&index=0&id=4afc6770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc6770",
  null
  
)

export default component.exports